import React from "react";

const mapCurrencyId=(currency_id)=>{
  if(currency_id === "1"){
      return 'EUR'
  }else if(currency_id === "2"){
      return 'SEK'
  }
}

export default function FormatedPrice({ value, currency_type}) {
  let currency = '';
  if(parseInt(currency_type)){
    currency = mapCurrencyId(currency_type);
  }else{
    currency = currency_type
  }
  const formatedValue = parseFloat(value).toFixed(0);
  return (<><span>{formatedValue}</span>&nbsp;<span>{currency}</span></>);
}
